export const locale = {
    id: 'nl-NL',
    prefix: '',
    mailDomain: 'nl',
};
